import { BrowserModule } from "@angular/platform-browser";

import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { FrontModule } from "./front/front.module";
import { ApiModule } from "./api/api.module";
import { NoopAnimationsModule } from "@angular/platform-browser/animations";
import { MatNativeDateModule } from "@angular/material/core";
import { MetaModule } from "./meta/meta.module";
import { JoyrideModule } from "ngx-joyride";
import { LayoutModule } from "./layout/layout.module";
import { GeneralModule } from "./general/general.module";
import { environment } from "../environments/environment";
import { AngularFireMessagingModule } from "@angular/fire/compat/messaging";
import { AngularFireModule } from "@angular/fire/compat";
import { appConfig } from "./app.config";

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    GeneralModule,
    NoopAnimationsModule,
    MatNativeDateModule,
    AppRoutingModule,
    LayoutModule,
    FrontModule,
    ApiModule,
    MetaModule,
    JoyrideModule.forRoot(),
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
  ],
  providers: [appConfig.providers],
})
export class AppModule {}
